import { createContext } from 'react';

const RailValuesContext = createContext({
  isWithinRail: false,
  positionedElements: [],
});

export default RailValuesContext;
